import React from 'react'
import Header from '../../layout/Header'
import Footer from '../../layout/Footer'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
function TestEnvironmentWelcome() {
      const { t } = useTranslation("TestEnvironmentWelcome");
    return (
        <>
            <Header />
            <section>
                <div className="container-fluid">
                    <div className="sign-up-main">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-12 col-md-6 position-relative bg-primary d-flex justify-content-center align-items-center sign-up-col vh-md-100">
                                <img
                                    src="./login/individual-user-vector-1.png"
                                    className="sing-vector-1"
                                    alt=""
                                />
                                <img
                                    src="./login/woman-home.webp"
                                    className="project-team"
                                    alt=""
                                />
                                <img
                                    src="./login/individual-user-vector-2.png"
                                    className="sing-vector-2"
                                    alt=""
                                />
                            </div>
                            <div className="col-12 col-md-6 px-4 px-lg-0 position-relative d-flex justify-content-center align-items-center sign-up-col sign-up-col-sm vh-md-100 pb-md-5">
                                <div className="col-12 col-md-12 col-lg-10 col-xl-9">
                                    <h3 className='welcome-title'>{t("welcome")} </h3>
                                    <p className='welcome-description'>{t("explore_platform")}</p>
                                    <p className='welcome-description'>{t("experience_features")}</p>
                                    <form className="row form-main payment-buttons">
                                        <div className="col-md-12">
                                            <Link
                                                to="/subscription-plans"
                                                className="btn-explore rounded-2 fw-400 d-inline-block mb-4 mb-md-5"
                                            >
                                               {t("activate_trial")}
                                            </Link>
                                            <p className='welcome-description'>{t("commit_now")}</p>
                                            <Link
                                                to="/subscription-plans"
                                                // to={"/business-home"}
                                                type='button'
                                                className="btn-primary rounded-2 fw-400"
                                            >
                                              {t("skip_payment")}
                                            </Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default TestEnvironmentWelcome
